import moment from "moment";
import { convertToPercent, deepCopy, getAppData, getDatesInRange, getDayDateKey, getFromState, getObjectFilter, getTransformedSegments, round, setUpDate } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";
import { transformSegmentData } from "../segmentedData";
import { getSegmentedCode } from "../processDataReports";
import { getKeyTotal } from "./pace_report_functions";



/*  */
export function getReportData_marketCode(columns, auth, app_state) {
    let data = deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;
    let dates = getDatesInRange(date_from, date_until);
    let segmentTotalAll = {};
    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    dates.map((date, dateIndex) => {
        // let dataRecord = data.filter((item) => moment(item.index.date).format("yyyy-mm-dd") === moment(date).format("yyyy-mm-dd"));
        let dataRecord = data.filter((item) => moment(item.index.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"));
        let segmentCodes = Object.keys(dataRecord[0]);
        segmentCodes.sort().push(segmentCodes.shift());

        segmentCodes.map((segmentCode, segmentIndex) => {
            if (segmentCode !== "index") {

                if (!segmentTotalAll[segmentCode]) {
                    segmentTotalAll[segmentCode] = {
                        primary: deepCopy(blankObj),
                        sdly: deepCopy(blankObj),
                        sdly_actual: deepCopy(blankObj),
                        difference_sdly: deepCopy(blankObj)
                    };
                }

                let data_columns = [];
                let segmentName = (segmentCode && segmentCode === "HotelTotal") ? "Total" : segmentCode.replaceAll("Segment_", "");
                let segmentKey = segmentCode;
                columns.map(col => {
                    let dataObj = {};
                    dataObj.id = col.id;

                    if (col.type === 'dateColumn') {
                        dataObj = setUpDate(dataObj, date);
                        dataObj["segment"] = segmentName;
                    }
                    if (col.type === 'dataColumn') {
                        let { mainKey } = col;
                        col.subcolumns.map(key => {
                            if (mainKey === "difference_sdly") {
                                if (key.value === "Occ") {
                                    let diffVal = convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]);
                                    dataObj[key.value] = diffVal;//convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value])
                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                } else {
                                    let diffVal = round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]);
                                    dataObj[key.value] = diffVal;//round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value])
                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                }
                            } else {
                                if (key.value == "Occ") {
                                    dataObj[key.value] = convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                    segmentTotalAll[segmentCode][mainKey][key.value] += convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                } else {
                                    dataObj[key.value] = round(dataRecord[0][segmentKey][mainKey][key.value]);
                                    segmentTotalAll[segmentCode][mainKey][key.value] += dataRecord[0][segmentKey][mainKey][key.value];
                                }
                            }
                        })
                    }

                    data_columns.push(dataObj);
                })
                setup_data.push(data_columns);
            }
        })
    })
    setup_data = [...setup_data, ...getTotalAll(segmentTotalAll, columns, app_state)]
    return setup_data;
}
/* */

/* for room type  */
export function getReportData_roomType(columns, auth, app_state, ui_state) {
    let inputData = (dataService.getSeriesById("GetRoomType").data) ? deepCopy(dataService.getSeriesById("GetRoomType").data.data) : [];
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(ui_state.showVariableCapacity);

    let segmentTotalAll = {};
    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let filteredSegment = [];
    const { active_tiles, table_filters } = ui_state;
    let dates = getDatesInRange(date_from, date_until);
    let data = inputData;

    if (data && data.length > 0) {
        dates.map((date, dateIndex) => {
            let dataRecord = data.filter((item) => moment(item.index.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"));
            let segmentCodes = Object.keys(dataRecord[0]);
            segmentCodes.map((segmentCode, segmentIndex) => {
                if (segmentCode !== "index") {

                    if (!segmentTotalAll[segmentCode]) {
                        segmentTotalAll[segmentCode] = {
                            primary: deepCopy(blankObj),
                            sdly: deepCopy(blankObj),
                            sdly_actual: deepCopy(blankObj),
                            sdtly: deepCopy(blankObj),
                            sdtly_actual: deepCopy(blankObj),
                            difference_sdly: deepCopy(blankObj),
                            variance_sdly: deepCopy(blankObj),
                            pickup_diff_sdly: deepCopy(blankObj)
                        };
                    }

                    let data_columns = [];
                    let segmentName = (segmentCode && segmentCode === "HotelTotal") ? "Total" : segmentCode.replaceAll("Segment_", "");
                    let segmentKey = segmentCode;
                    // Available for a given mainKey ("primary"/"sdly"/"sdtly"/"sdly_actual"/"sdtly_actual"):
                    // HotelTotal row uses hotel-wide capacity gated by the VCap toggle, individual room
                    // type rows always use their own VCapacityRt/Capacity regardless of the toggle —
                    // mirrors the generic-branch Available handling below.
                    const getVcapForRoomTypeKey = (mk) => {
                        if (segmentCode === 'HotelTotal') {
                            const vCapVC = dataRecord[0]["HotelTotal"]?.[mk]?.VCapacity;
                            return useVarCapacity ? (vCapVC || dataRecord[0]["HotelTotal"]?.[mk]?.Capacity) : dataRecord[0]["HotelTotal"]?.[mk]?.Capacity;
                        }
                        const rtVCap = dataRecord[0][segmentKey]?.[mk]?.VCapacityRt;
                        const rtCap = dataRecord[0][segmentKey]?.[mk]?.Capacity;
                        return rtVCap || rtCap;
                    };
                    const getAvailForKey = (mk) => {
                        const vcap = getVcapForRoomTypeKey(mk);
                        const rooms = dataRecord[0][segmentKey]?.[mk]?.Rooms;
                        return (vcap && rooms !== undefined) ? round(vcap - rooms) : null;
                    };
                    columns.map(col => {
                        let dataObj = {};
                        dataObj.id = col.id;
                        let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                        let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";

                        if (col.type === 'dateColumn') {
                            dataObj = setUpDate(dataObj, date);
                            dataObj["segment"] = segmentName;
                        }
                        if (col.type === 'dataColumn') {
                            let { mainKey } = col;
                            col.subcolumns.map(key => {
                                if (mainKey === "difference_sdly") {
                                    if (key.value === "Occ") {
                                        let diffVal = convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                        let totalDiff = convertToPercent(getKeyTotal(dataRecord[0], key.value, filteredSegment, 'primary') - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey))
                                        dataObj[key.value] = (segmentName === 'Total_x') ? totalDiff : diffVal;
                                        segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                    } else if (key.value === "Available") {
                                        const avail1 = getAvailForKey("primary");
                                        const avail2 = getAvailForKey(dayDateKey);
                                        let diffVal = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                        dataObj[key.value] = diffVal;
                                        segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                        if (segmentCode === 'HotelTotal') {
                                            const vcap1 = getVcapForRoomTypeKey("primary");
                                            const vcap2 = getVcapForRoomTypeKey(dayDateKey);
                                            // Segmented-view Total row gets rebuilt by summing the
                                            // individual room type rows (TableReports.js getTotalData),
                                            // which drops Available — this restores it the same way
                                            // the TY/LY columns already do.
                                            if (vcap1 && vcap2) dataObj._vcap = round(vcap1 - vcap2);
                                        }
                                    } else {
                                        let diffVal = round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                        let totalDiff = round(getKeyTotal(dataRecord[0], key.value, filteredSegment, 'primary') - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey))
                                        dataObj[key.value] = (segmentName === 'Total_x') ? totalDiff : diffVal;
                                        segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                    }
                                } else if (mainKey === "variance_sdly") {
                                    let variance_diff;
                                    if (key.value === "Available") {
                                        const avail1 = getAvailForKey("primary");
                                        const avail2 = getAvailForKey(dayDateKey);
                                        variance_diff = (avail1 !== null && avail2) ? convertToPercent((avail1 - avail2) / avail2) : 0;
                                    } else {
                                        variance_diff = convertToPercent((dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]) / dataRecord[0][segmentKey][dayDateKey][key.value]);
                                    }
                                    variance_diff = (variance_diff && isFinite(variance_diff)) ? variance_diff : 0;
                                    let varianceTotalDiff = convertToPercent((getKeyTotal(dataRecord[0], key.value, filteredSegment, 'primary') - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey)) / getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey));
                                    dataObj[key.value] = (segmentName === 'Total_x') ? varianceTotalDiff + "%" : variance_diff + "%";
                                    segmentTotalAll[segmentCode][mainKey][key.value] += variance_diff;

                                } else if (mainKey === "pickup_diff_sdly") {
                                    let pickup_diff ;
                                    if (key.value == "Occ") {
                                        pickup_diff =  convertToPercent(dataRecord[0][segmentKey][dayDate_sdly_actual][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                    } else if (key.value === "Available") {
                                        const avail1 = getAvailForKey(dayDate_sdly_actual);
                                        const avail2 = getAvailForKey(dayDateKey);
                                        pickup_diff = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                        if (segmentCode === 'HotelTotal') {
                                            const vcap1 = getVcapForRoomTypeKey(dayDate_sdly_actual);
                                            const vcap2 = getVcapForRoomTypeKey(dayDateKey);
                                            if (vcap1 && vcap2) dataObj._vcap = round(vcap1 - vcap2);
                                        }
                                    }else{
                                        pickup_diff = round(dataRecord[0][segmentKey][dayDate_sdly_actual][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                    }
                                    let totalDiff = round(getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDate_sdly_actual) - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey))
                                    if(key.value === "ADR"){
                                        let revTotal =  dataRecord[0][segmentKey][dayDate_sdly_actual]['Revenue'] - dataRecord[0][segmentKey][dayDateKey]['Revenue'];
                                        let roomsSATotal =  dataRecord[0][segmentKey][dayDate_sdly_actual]['Rooms'] - dataRecord[0][segmentKey][dayDateKey]['Rooms']
                                        dataObj[key.value] = revTotal / roomsSATotal;
                                        segmentTotalAll[segmentCode][mainKey][key.value] += revTotal / roomsSATotal;
                                    }else{
                                        dataObj[key.value] = (segmentName === 'Total_x') ? totalDiff : pickup_diff;
                                        segmentTotalAll[segmentCode][mainKey][key.value] += pickup_diff;
                                    }
                                } else {
                                    mainKey = getDayDateKey(dayDate, mainKey);
                                    if (key.value == "Occ") {
                                        const vCapVC = dataRecord[0]["HotelTotal"]?.[mainKey]?.VCapacity;
                                        const hotelCapacity = useVarCapacity
                                            ? (vCapVC || dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity)
                                            : dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                        dataObj[key.value] = hotelCapacity
                                            ? convertToPercent(dataRecord[0][segmentKey][mainKey]["Rooms"] / hotelCapacity)
                                            : convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                        if (segmentCode === 'HotelTotal') {
                                            const vCap = vCapVC || dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                            if (vCap) {
                                                dataObj._vcap = useVarCapacity ? vCap : dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                                dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                                dataObj._vcapDiffers = !!(vCapVC && vCapVC !== dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity);
                                            }
                                        } else {
                                            const rtVCap = dataRecord[0][segmentKey]?.[mainKey]?.VCapacityRt;
                                            const rtCap = dataRecord[0][segmentKey]?.[mainKey]?.Capacity;
                                            const rtEffCap = rtVCap || rtCap;
                                            if (rtEffCap) {
                                                dataObj._rtVcap = rtEffCap;
                                                dataObj._rtVcapLabel = rtVCap ? 'Variable Capacity' : 'Capacity';
                                                dataObj._rtVcapDiffers = !!(rtVCap && rtVCap !== rtCap);
                                            }
                                        }
                                        segmentTotalAll[segmentCode][mainKey][key.value] += convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                    } else if (key.value === "Available") {
                                        if (segmentCode === 'HotelTotal') {
                                            const vCapVC = dataRecord[0]["HotelTotal"]?.[mainKey]?.VCapacity;
                                            const hotelVcap = useVarCapacity ? (vCapVC || dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity) : dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                            dataObj[key.value] = hotelVcap ? round(hotelVcap - dataRecord[0][segmentKey][mainKey]['Rooms']) : 0;
                                        } else {
                                            const rtVCap = dataRecord[0][segmentKey]?.[mainKey]?.VCapacityRt;
                                            const rtCap = dataRecord[0][segmentKey]?.[mainKey]?.Capacity;
                                            const rtEffCap = rtVCap || rtCap;
                                            dataObj[key.value] = rtEffCap ? round(rtEffCap - dataRecord[0][segmentKey][mainKey]['Rooms']) : 0;
                                        }
                                    } else {
                                        if (key.value === "RevPAR") {
                                            const vCapVC = dataRecord[0]["HotelTotal"]?.[mainKey]?.VCapacity;
                                            const capacityForRevPAR = useVarCapacity ? (vCapVC || dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity) : dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                            dataObj[key.value] = capacityForRevPAR ? round(dataRecord[0][segmentKey][mainKey]["Revenue"] / capacityForRevPAR) : round(dataRecord[0][segmentKey][mainKey][key.value]);
                                        } else {
                                            dataObj[key.value] = (segmentName === 'Total_x') ? round(getKeyTotal(dataRecord[0], key.value, filteredSegment, mainKey)) : round(dataRecord[0][segmentKey][mainKey][key.value]);
                                        }
                                        segmentTotalAll[segmentCode][mainKey][key.value] += dataRecord[0][segmentKey][mainKey][key.value];
                                    }
                                }
                            })
                        }

                        data_columns.push(dataObj);
                    })
                    setup_data.push(data_columns);
                }
            })
        })
        let segFinalTotal = getTotalAll(segmentTotalAll, columns, app_state);
        if (app_state.workspace_controls.sdlyOn) {
            segFinalTotal.map((item, index) => {
                let keysArr = Object.keys(segFinalTotal[index][5])
                keysArr.map((itm, idx) => {
                    if (itm !== "id") {
                        segFinalTotal[index][5][itm] = (isFinite(segFinalTotal[index][5][itm])) ? segFinalTotal[index][5][itm] + "%" : 0 + "%";
                    }
                })
            })
        }

        // setup_data = [...setup_data, ...segFinalTotal]
    }
    return setup_data;
}
/* */




/* for room class  */
export function getReportData_roomClass(columns, auth, app_state, ui_state) {
    let data = deepCopy(dataService.getSeriesById("GetRoomType").data.data);
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;
    let dates = getDatesInRange(date_from, date_until);
    let segmentTotalAll = {};
    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    dates.map((date, dateIndex) => {
        let dataRecord = data.filter((item) => moment(item.index.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"));
        let segmentCodes = Object.keys(dataRecord[0]);
        segmentCodes.sort().push(segmentCodes.shift());
        segmentCodes.map((segmentCode, segmentIndex) => {
            if (segmentCode !== "index") {

                if (!segmentTotalAll[segmentCode]) {
                    segmentTotalAll[segmentCode] = {
                        primary: deepCopy(blankObj),
                        sdly: deepCopy(blankObj),
                        sdly_actual: deepCopy(blankObj),
                        difference_sdly: deepCopy(blankObj),
                        variance_sdly: deepCopy(blankObj),
                        pickup_diff_sdly: deepCopy(blankObj)
                    };
                }

                let data_columns = [];
                let segmentName = (segmentCode && segmentCode === "HotelTotal") ? "Total" : segmentCode.replaceAll("Segment_", "");
                let segmentKey = segmentCode;
                columns.map(col => {
                    let dataObj = {};
                    dataObj.id = col.id;

                    if (col.type === 'dateColumn') {
                        dataObj = setUpDate(dataObj, date);
                        dataObj["segment"] = segmentName;
                    }
                    if (col.type === 'dataColumn') {
                        let { mainKey } = col;
                        col.subcolumns.map(key => {
                            if (mainKey === "difference_sdly") {
                                if (key.value === "Occ") {
                                    let diffVal = convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]);
                                    dataObj[key.value] = diffVal;//convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value])
                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                } else {
                                    let diffVal = round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]);
                                    dataObj[key.value] = diffVal;//round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value])
                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                }
                            } else if (mainKey === "variance_sdly") {
                                let variance_diff = convertToPercent((dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]) / dataRecord[0][segmentKey]["sdly"][key.value]);
                                dataObj[key.value] = variance_diff + "%";
                                segmentTotalAll[segmentCode][mainKey][key.value] += variance_diff;

                            } else if (mainKey === "pickup_diff_sdly") {
                                let pickup_diff = round(dataRecord[0][segmentKey]["sdly_actual"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]);
                                dataObj[key.value] = pickup_diff;
                                segmentTotalAll[segmentCode][mainKey][key.value] += pickup_diff; //round(dataRecord[0][segmentKey]["sdly_actual"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value]);

                            } else {
                                if (key.value == "Occ") {
                                    dataObj[key.value] = convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                    segmentTotalAll[segmentCode][mainKey][key.value] += convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                } else {
                                    dataObj[key.value] = round(dataRecord[0][segmentKey][mainKey][key.value]);
                                    segmentTotalAll[segmentCode][mainKey][key.value] += dataRecord[0][segmentKey][mainKey][key.value];
                                }
                            }
                        })
                    }

                    data_columns.push(dataObj);
                })
                setup_data.push(data_columns);
            }
        })
    })
    let segFinalTotal = getTotalAll(segmentTotalAll, columns, app_state);
    if (app_state.workspace_controls.sdlyOn) {
        segFinalTotal.map((item, index) => {
            let keysArr = Object.keys(segFinalTotal[index][5])
            keysArr.map((itm, idx) => {
                if (itm !== "id") {
                    segFinalTotal[index][5][itm] = (isFinite(segFinalTotal[index][5][itm])) ? segFinalTotal[index][5][itm] + "%" : 0 + "%";
                }
            })
        })
    }
    setup_data = [...setup_data, ...segFinalTotal]
    return setup_data;
}
/* */



/* for rate plan  */
export function getReportData_ratePlan(columns, auth, app_state, ui_state) {
    let inputData = (dataService.getSeriesById("GetRatePlanNoMissingDays").data) ? deepCopy(dataService.getSeriesById("GetRatePlanNoMissingDays").data.data) : [];
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(ui_state.showVariableCapacity);
    let segmentTotalAll = {};
    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };

    const { active_tiles, table_filters } = ui_state;
    let filteredSegment = [];
    let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
    let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";
    let dates = getDatesInRange(date_from, date_until);

    let data = inputData;
    dates.map((date, dateIndex) => {
        let dataRecord = data.filter((item) => moment(item.index.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"));
        let recordArr = dataRecord[0];
        if (dataRecord && dataRecord.length <= 0) {
            let testObj = {
                index: { date: date },
                "Segment_blank": {
                    primary: deepCopy(blankObj),
                    sdly: deepCopy(blankObj),
                    sdly_actual: deepCopy(blankObj),
                    sdtly: deepCopy(blankObj),
                    sdtly_actual: deepCopy(blankObj),
                    difference_sdly: deepCopy(blankObj),
                    variance_sdly: deepCopy(blankObj),
                    pickup_diff_sdly: deepCopy(blankObj)
                }
            }
            dataRecord[0] = testObj;
        }

        let segmentCodes = Object.keys(dataRecord[0]);      
        segmentCodes.map((segmentCode, segmentIndex) => {
            if (segmentCode !== "index") {
                if (!segmentTotalAll[segmentCode]) {
                    segmentTotalAll[segmentCode] = {
                        primary: deepCopy(blankObj),
                        sdly: deepCopy(blankObj),
                        sdly_actual: deepCopy(blankObj),
                        sdtly: deepCopy(blankObj),
                        sdtly_actual: deepCopy(blankObj),
                        difference_sdly: deepCopy(blankObj),
                        variance_sdly: deepCopy(blankObj),
                        pickup_diff_sdly: deepCopy(blankObj)
                    };
                }

                let data_columns = [];
                let segmentName = (segmentCode && segmentCode === "HotelTotal") ? "Total" : segmentCode.replaceAll("Segment_", "");
                let segmentKey = segmentCode;
                // Rate plans don't carry their own capacity — Available always derives from the
                // shared hotel-wide VCap, same denominator used for Occ%/RevPAR below.
                const getVcapForRatePlanKey = (mk) => useVarCapacity
                    ? (dataRecord[0]["HotelTotal"]?.[mk]?.VCapacity || dataRecord[0]["HotelTotal"]?.[mk]?.Capacity || null)
                    : (dataRecord[0]["HotelTotal"]?.[mk]?.Capacity || null);
                const getAvailForKey = (mk) => {
                    const vcap = getVcapForRatePlanKey(mk);
                    const rooms = dataRecord[0][segmentKey]?.[mk]?.Rooms;
                    return (vcap && rooms !== undefined) ? round(vcap - rooms) : null;
                };
                columns.map(col => {
                    let dataObj = {};
                    dataObj.id = col.id;

                    if (col.type === 'dateColumn') {
                        dataObj = setUpDate(dataObj, date);
                        dataObj["segment"] = (segmentName && segmentName !== "blank") ? segmentName : "No Data";
                    }
                    if (col.type === 'dataColumn') {
                        let { mainKey } = col;
                        col.subcolumns.map(key => {
                            if (mainKey === "difference_sdly") {
                                if (key.value === "Occ") {
                                    let diffVal = convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                    // dataObj[key.value] = diffVal;//convertToPercent(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value])
                                    let totalDiff = convertToPercent(getKeyTotal(dataRecord[0], key.value, filteredSegment, 'primary') - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey))
                                    dataObj[key.value] = (segmentName === 'Total_x') ? totalDiff : diffVal;

                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                } else if (key.value === "Available") {
                                    const avail1 = getAvailForKey("primary");
                                    const avail2 = getAvailForKey(dayDateKey);
                                    let diffVal = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                    dataObj[key.value] = diffVal;
                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                    if (segmentCode === 'HotelTotal') {
                                        const vcap1 = getVcapForRatePlanKey("primary");
                                        const vcap2 = getVcapForRatePlanKey(dayDateKey);
                                        // Segmented-view Total row gets rebuilt by summing the
                                        // individual rate plan rows (TableReports.js getTotalData),
                                        // which drops Available — this restores it the same way
                                        // the TY/LY columns already do.
                                        if (vcap1 && vcap2) dataObj._vcap = round(vcap1 - vcap2);
                                    }
                                } else {
                                    let diffVal = round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                    let totalDiff = round(getKeyTotal(dataRecord[0], key.value, filteredSegment, 'primary') - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey))
                                    dataObj[key.value] = (segmentName === 'Total_x') ? totalDiff : diffVal;

                                    // dataObj[key.value] = diffVal;//round(dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey]["sdly"][key.value])
                                    segmentTotalAll[segmentCode][mainKey][key.value] += diffVal;
                                }
                            } else if (mainKey === "variance_sdly") {
                                let variance_diff;
                                if (key.value === "Available") {
                                    const avail1 = getAvailForKey("primary");
                                    const avail2 = getAvailForKey(dayDateKey);
                                    variance_diff = (avail1 !== null && avail2) ? (avail1 - avail2) / avail2 : 0;
                                } else {
                                    variance_diff = (dataRecord[0][segmentKey]["primary"][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]) / dataRecord[0][segmentKey][dayDateKey][key.value];
                                }
                                let variance_value = (variance_diff && isFinite(variance_diff)) ? (variance_diff * 100) : 0.00;
                                let varianceTotalDiff = convertToPercent((getKeyTotal(dataRecord[0], key.value, filteredSegment, 'primary') - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey)) / getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey));
                                let variance_total_value = (varianceTotalDiff && isFinite(varianceTotalDiff)) ? (varianceTotalDiff * 100) : 0.00;

                                dataObj[key.value] = (segmentName === 'Total_x') ? variance_total_value + "%" : variance_value + "%";
                                segmentTotalAll[segmentCode][mainKey][key.value] += variance_value;

                            } else if (mainKey === "pickup_diff_sdly") {
                                let pickup_diff ;
                                if (key.value == "Occ") {
                                    pickup_diff = convertToPercent(dataRecord[0][segmentKey][dayDate_sdly_actual][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                } else if (key.value === "Available") {
                                    const avail1 = getAvailForKey(dayDate_sdly_actual);
                                    const avail2 = getAvailForKey(dayDateKey);
                                    pickup_diff = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                    if (segmentCode === 'HotelTotal') {
                                        const vcap1 = getVcapForRatePlanKey(dayDate_sdly_actual);
                                        const vcap2 = getVcapForRatePlanKey(dayDateKey);
                                        if (vcap1 && vcap2) dataObj._vcap = round(vcap1 - vcap2);
                                    }
                                }else{
                                    pickup_diff = round(dataRecord[0][segmentKey][dayDate_sdly_actual][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value]);
                                }
                                let totalDiff = round(getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDate_sdly_actual) - getKeyTotal(dataRecord[0], key.value, filteredSegment, dayDateKey))
                                dataObj[key.value] = (segmentName === 'Total_x') ? totalDiff : pickup_diff;
                                segmentTotalAll[segmentCode][mainKey][key.value] += pickup_diff;

                            } else {
                                 mainKey = getDayDateKey(dayDate, mainKey);
                                const hotelVCap = useVarCapacity
                                    ? (dataRecord[0]["HotelTotal"]?.[mainKey]?.VCapacity || dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity || null)
                                    : (dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity || null);
                                if (key.value == "Occ") {
                                    const occVal = hotelVCap
                                        ? dataRecord[0][segmentKey][mainKey]["Rooms"] / hotelVCap
                                        : dataRecord[0][segmentKey][mainKey][key.value];
                                    dataObj[key.value] = (segmentName === 'Total_xx') ? convertToPercent(getKeyTotal(dataRecord[0], key.value, filteredSegment, mainKey)) : convertToPercent(occVal);
                                    if (segmentCode === 'HotelTotal') {
                                        const vCapVC = dataRecord[0]["HotelTotal"]?.[mainKey]?.VCapacity;
                                        const vCap = vCapVC || dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                        if (vCap) {
                                            dataObj._vcap = useVarCapacity ? vCap : dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity;
                                            dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                            dataObj._vcapDiffers = !!(vCapVC && vCapVC !== dataRecord[0]["HotelTotal"]?.[mainKey]?.Capacity);
                                        }
                                    }
                                    segmentTotalAll[segmentCode][mainKey][key.value] += convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                } else if (key.value === "Available") {
                                    const rooms = dataRecord[0][segmentKey]?.[mainKey]?.Rooms;
                                    const availVal = (hotelVCap && rooms !== undefined) ? round(hotelVCap - rooms) : 0;
                                    dataObj[key.value] = availVal;
                                    segmentTotalAll[segmentCode][mainKey][key.value] += availVal;
                                } else {
                                    if (key.value === "RevPAR" && hotelVCap) {
                                        dataObj[key.value] = (segmentName === 'Total_xx') ? round(getKeyTotal(dataRecord[0], key.value, filteredSegment, mainKey)) : round(dataRecord[0][segmentKey][mainKey]["Revenue"] / hotelVCap);
                                    } else {
                                        dataObj[key.value] = (segmentName === 'Total_xx') ? round(getKeyTotal(dataRecord[0], key.value, filteredSegment, mainKey)) : round(dataRecord[0][segmentKey][mainKey][key.value]);
                                    }
                                    segmentTotalAll[segmentCode][mainKey][key.value] += dataRecord[0][segmentKey][mainKey][key.value];
                                }
                            }
                        })
                    }

                    data_columns.push(dataObj);
                })
                setup_data.push(data_columns);
            }
        })
    })
    let segFinalTotal = getTotalAll(segmentTotalAll, columns, app_state);
    if (app_state.workspace_controls.sdlyOn) {
        segFinalTotal.map((item, index) => {
            let keysArr = Object.keys(segFinalTotal[index][5])
            keysArr.map((itm, idx) => {
                if (itm !== "id") {
                    segFinalTotal[index][5][itm] = (isFinite(segFinalTotal[index][5][itm])) ? segFinalTotal[index][5][itm] + "%" : 0 + "%";
                }
            })
        })
    }
    setup_data = [...setup_data, ...segFinalTotal]
    return setup_data;
}
/* */




const getTotalAllSegment = (key, dataObj, app_state) => {
    var date1 = moment(app_state.primary_stay_range.date_from);
    var date2 = moment(app_state.primary_stay_range.date_until);
    var daysCount = date2.diff(date1, 'days') + 1;
    let finalValue = 0;
    let value = dataObj[key];
    if (key === "Occ") {
        finalValue = value / daysCount;
    } else if (key === "ADR") {
        finalValue = dataObj["Revenue"] / dataObj["Rooms"];
    } else if (key === "RevPAR") {
        finalValue = value / daysCount;
    } else {
        finalValue = value;
    }
    return finalValue;
}


function getTotalAll(segmentTotalAll, columns, app_state) {
    let setup_data = [];
    let segmentCodes = Object.keys(segmentTotalAll);
    segmentCodes.sort().push(segmentCodes.shift());

    segmentCodes.map((segmentCode, segmentIndex) => {
        // console.log("segmentCodesegmentCode ",segmentCode);
        if (segmentCode !== "HotelTotal" && segmentCode !== "Segment_blank") {
            let data_columns = [];
            let segmentName = (segmentCode && segmentCode === "HotelTotal") ? "Total" : segmentCode.replaceAll("Segment_", "");

            // let segmentName = (segmentCode && segmentCode === "HotelTotal") ? "Total" : getCodeDetails(segmentCode,app_state);
            let segmentKey = segmentCode;
            columns.map(col => {
                let dataObj = {};
                dataObj.id = col.id;

                if (col.type === 'dateColumn') {
                    dataObj = setUpDate(dataObj, "");
                    dataObj["segment"] = segmentName;
                }
                if (col.type === 'dataColumn') {
                    let { mainKey } = col;
                    col.subcolumns.map(key => {
                        console.log();
                        if (mainKey === "difference_sdly") {
                            if (key.value === "ADR") {
                                let diffADR = getTotalAllSegment("ADR", segmentTotalAll[segmentKey]["primary"], app_state) - getTotalAllSegment("ADR", segmentTotalAll[segmentKey]["sdly"], app_state);
                                dataObj[key.value] = diffADR; //segmentTotalAll[segmentKey]["primary"][key.value] - segmentTotalAll[segmentKey]["sdly"][key.value];
                            } else {
                                dataObj[key.value] = getTotalAllSegment(key.value, segmentTotalAll[segmentKey][mainKey], app_state);
                            }
                        } else {
                            dataObj[key.value] = getTotalAllSegment(key.value, segmentTotalAll[segmentKey][mainKey], app_state);

                        }
                    })
                }
                data_columns.push(dataObj);
            })
            setup_data.push(data_columns);
        }
    })
    return setup_data;
}




